import { IconCheck } from './svg/IconCheck';

import './Icon.style.sass';

export const CheckGreen = () => (
  <div className="check-line">
    <IconCheck />
  </div>
);
